<script lang="ts">
    import Button from "../../../widgets/Button.svelte"

    export let column: BlockColumn<"cta">
    const cta = column.cta
</script>

<div
    class="cta"
    id="cta"
>
    {#if cta.upperHeadline}
        <small>
            {cta.upperHeadline}
        </small>
    {/if}

    <h1>
        {cta.whiteHeadline}
        {#if cta.headlineArrangement !== "row"} <br />{/if} <em class="red">{cta.redHeadline}</em>
    </h1>

    <p>{cta.description}</p>
    <div class="buttons">
        {#each cta.callToActionButtons as button}
            <Button button="{button}" />
        {/each}
    </div>
</div>

<style lang="less">
    #cta {
        display: flex;
        flex-direction: column;
        gap: 1.6rem;

        small {
            text-transform: uppercase;
            font-weight: 700;
            font-family: Outfit-Bold, sans-serif;
            color: var(--text-100);
        }
        p {
            font-size: 1.2rem;
            color: var(--text-100);
        }
        .buttons {
            display: flex;
            gap: 0.3rem;
        }
    }
</style>
